import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const ArrowRightCircled = memo(
  forwardRef((props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 16 16" data-fill-none>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6692 8.59828C11.1129 8.29435 11.1129 7.70564 10.6692 7.40164L7.40066 5.16234C6.83225 4.77292 6.00195 5.1281 6.00195 5.76062L6.00195 10.2393C6.00195 10.8719 6.83225 11.2271 7.40066 10.8377L10.6692 8.59828Z"
        fill={COLORS.neutral.darkGray}
      />
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="7.5"
        stroke={COLORS.neutral.darkGray}
      />
    </SvgIcon>
  ))
);
